function recherche(obj, point) {
    var ville = point.ville.toLowerCase().startsWith(obj.toLowerCase());
    var nom = point.nom.toLowerCase().startsWith(obj.toLowerCase());
    var codePostal = point['code_postal'].toLowerCase().startsWith(obj.toLowerCase());
    return nom || ville || codePostal;
}

export { recherche };
